import { FC } from 'react';

import { Button, ButtonGroup, HStack, Text } from '@chakra-ui/react';

import type { EditorCanvasSession } from './useEditorCanvasSession';

type Props = {
  session: EditorCanvasSession;
};

export const EditorCanvasControls: FC<Props> = ({ session }) => {
  return (
    <HStack spacing={3} mb={3} flexWrap="wrap" data-test-id="editor-canvas-controls">
      <ButtonGroup size="sm" isAttached variant="outline">
        <Button onClick={() => session.setZoom(0.5)}>50%</Button>
        <Button onClick={() => session.setZoom(1)}>100%</Button>
        <Button onClick={() => session.setZoom(2)}>200%</Button>
      </ButtonGroup>
      <Button size="sm" variant="outline" onClick={session.resetViewport}>
        Reset viewport
      </Button>
      <Button size="sm" variant="outline" onClick={() => session.panByScreen({ x: 40, y: 20 })}>
        Pan +40,+20
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={session.undo}
        isDisabled={session.undoDepth === 0}
      >
        Undo
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={session.redo}
        isDisabled={session.redoDepth === 0}
      >
        Redo
      </Button>
      <Text fontSize="xs" color="gray.600" data-test-id="editor-canvas-undo-depth">
        Undo {session.undoDepth} / Redo {session.redoDepth}
      </Text>
    </HStack>
  );
};

EditorCanvasControls.displayName = 'EditorCanvasControls';
